<template>
  <div class="app-change-auto-top-up-wrapper">
    <slot v-if="noPayment" :name="`headlineBeforeChangeAutoTopUpNoPayment`"></slot>
    <slot v-if="canDeactivate" :name="`headlineBeforeChangeAutoTopUp${autoTopUp.topUp.type}`"></slot>
    <slot v-if="canActivate" name="headlineBeforeChangeAutoTopUp"></slot>
    <slot name="txtBeforeChangeAutoTopUpNoPayment" v-if="noPayment"></slot>
    <activate-auto-top-up-wrapper
      v-if="showActivateAutoTopUpWrapper"
      :monthly-value="monthlyValue"
      :auto-top-up="topUp"
      @refresh="refreshQuery()"
      :payment-type="paymentType"
    >
      <template v-for="slot in possibleChildSlotsFor('Activate')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </activate-auto-top-up-wrapper>
    <!--     <button v-on:click="deactivateTopUp" class="btn-next" type="button" variant="primary" :disabled="loading">
      <slot name="btnNext">Automatische Aufladung deaktivieren</slot>
    </button> -->
    <div class="noSavedPayment" v-if="noPayment">
      <div class="text">
        <slot name="txtChangeAutoTopBeforeAutoTopUp"></slot>
      </div>
      <div class="noPayment">
        <slot name="txtChangeAutoTopNoSavedPayment"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import ActivateAutoTopUpWrapper from './ActivateAutoTopUpWrapper.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import { mapActions } from 'vuex'

export default {
  name: 'ChangeAutoTopUpWrapper',
  data() {
    return {
      loading: false,
      monthlyValue: [2],
      autoTopUp: {
        activationPossible: false,
        active: false,
        topUp: {
          amount: 0,
          trigger: 0,
          type: null
        },
        paymentType: null
      }
    }
  },
  methods: {
    refreshQuery() {
      this.$apollo.queries.autoTopUp.refresh()
    },
    deactivateTopUp() {
      this.loading = true
      this.deactivateAutoTopUp().then(
        () => {
          this.loading = false
          this.refreshQuery()
        },
        () => {
          this.loading = false
        }
      )
    },
    ...mapActions('topUp', ['deactivateAutoTopUp'])
  },
  components: { ActivateAutoTopUpWrapper },
  computed: {
    paymentType() {
      return this.autoTopUp.paymentType
    },
    canDeactivate() {
      return this.autoTopUp.active
    },
    noPayment() {
      return this.autoTopUp.activationPossible === false
    },
    canActivate() {
      return this.canDeactivate === false && this.autoTopUp.activationPossible
    },
    showActivateAutoTopUpWrapper() {
      return (this.canActivate || this.canDeactivate) && !this.noPayment
    },
    showButtonNextOverlay() {
      return this.canDeactivate && this.page !== 'overview'
    },
    topUp() {
      return {
        ...this.autoTopUp.topUp,
        type: this.type,
        active: this.autoTopUp.active
      }
    },
    type() {
      if (this.autoTopUp?.topUp?.type === 'ACCOUNT_BALANCE') {
        return 'byLimit'
      } else if (this.autoTopUp?.topUp?.type === 'DAY_OF_MONTH') {
        return 'monthly'
      } else {
        return null
      }
    }
  },
  mixins: [transaction('changeAutoTopUp'), slotProxy()],

  props: ['page'],
  apollo: {
    autoTopUp: function() {
      return wrapQuery(
        gql`
          query changeAutoTopUp {
            autoTopUp {
              activationPossible
              active
              topUp {
                amount
                trigger
                type
              }
              paymentType {
                ... on BankAccount {
                  type
                  iban
                  owner
                }
                ... on CreditCard {
                  type
                  holder
                  company
                  expiryMonth
                  expiryYear
                  lastDigits
                }
              }
            }
          }
        `,
        this,
        'autoTopUp'
      )
    }
  }
}
</script>
